// 倒计时
import { useEffect, useState, useRef, useCallback } from 'react';
import DateJS from '@/utils/date';

interface IOption {
  targetValue?: number; // 总时间 秒
  interval?: number; // 倒计时间隔
  onEnd?: () => void;
}

const useCountdown: (option: IOption) => [number, (time: number) => void, () => void] = (
  option,
) => {
  const { targetValue, interval, onEnd } = option || {};
  const [timeLeft, setTimeLeft] = useState(targetValue || 0);
  const onEndRef = useRef(() => {});
  const tickTimer = useRef(null);
  onEndRef.current = onEnd;

  const clearTickTimer = () => {
    if (tickTimer.current) {
      clearTimeout(tickTimer.current);
      tickTimer.current = null;
    }
  };

  const startCountDown = useCallback((timeValue: number) => {
    clearTickTimer();
    if (!timeValue) return;
    const currentTime = DateJS(); // 当前时间

    // 已消耗时间 秒
    const getTimeUse = () => {
      return DateJS().diff(currentTime, 'seconds');
    };

    // 时间更新
    const updateTime = () => {
      const useValue = getTimeUse();
      let leftValue = timeValue - useValue;
      if (leftValue <= 0) {
        leftValue = 0;
      }
      setTimeLeft(leftValue);
      if (!leftValue) {
        clearTickTimer();
        onEndRef.current?.();
      } else {
        // 时间间隔只取一次 默认1秒
        tickTimer.current = setTimeout(updateTime, interval || 1000);
      }
    };

    updateTime(); // 立即执行一次
  }, []);

  useEffect(() => {
    if (targetValue) {
      startCountDown(targetValue);
    }

    return clearTickTimer;
  }, [targetValue]);

  return [timeLeft, startCountDown, clearTickTimer];
};

export default useCountdown;
